import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import withFieldError from 'components/form/with-error'

// The CTA post the intent classifier matches a comment against. The evaluator
// reads it from the first MATCH_INTENT trigger's data.ctaPost.
export const CtaPostInput = ({ input, meta: { error, touched } }) => (
  <textarea
    {...input}
    rows={3}
    placeholder='Paste the CTA post copy that comments are matched against'
    className={'form-control ' + (error && touched ? 'has-error' : '')}
  />
)

CtaPostInput.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const CtaPostField = withFieldError(CtaPostInput)

export const validate = value =>
  value && value.trim()
    ? undefined
    : 'Enter the CTA post the classifier matches comments against'

const MatchIntentField = ({ name }) => (
  <div>
    <Field
      name={`${name}.ctaPost`}
      component={CtaPostField}
      validate={validate}
    />
  </div>
)

MatchIntentField.propTypes = {
  name: PropTypes.string
}

export default MatchIntentField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/twitter/match-intent/index.js